import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputLabel from "@material-ui/core/InputLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormControl from "@material-ui/core/FormControl";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import PersonIcon from "@material-ui/icons/Person";
import LockIcon from "@material-ui/icons/Lock";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";

import { checkLoginDetailsApi } from "../apis/api";

import { initializeApp, getApps, getApp } from "firebase/app";
import {
  getFirestore,
  collection,
  doc,
  query,
  where,
  orderBy,
  startAfter,
  limit,
  getDoc,
  getDocs,
} from "firebase/firestore";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";

import loginBgImg from "../assets/images/login-bg-image.svg";
import amuraLogo from "../assets/images/amura-login-logo.svg";
import LightUpTextImg from "../assets/images/lightUp-text-image.svg";
// import loginBgImg from "../assets/images/Rectangle74.svg";

import "../styles/login.scss";
import { checkMasterSession, 
  getCheckSession, 
  getServiceCustomToken, 
  setUserName,
  getUserName, 
  logInWithCustomToken, 
  logInWithEmailAndPassword, 
  masterLogout, 
  setServiceConfig,
  getIdToken, 
  setIsAdmin,
  setUserAccessList} from "../apis/auth";
import { getUser } from "../query/users.query";
import { getAllDbSettingList, getDbSettingList } from "../query/db-settings.query";
import { MenuItem, Select } from "@material-ui/core";

// const firebaseConfig = {
//   apiKey: "AIzaSyBrg5hfc-ZMCDuAgZxgnvBwLxOgeo0idcQ",
//   authDomain: "ccms-main-qe.firebaseapp.com",
//   databaseURL:
//     "https://ccms-main-qe-default-rtdb.asia-southeast1.firebasedatabase.app",
//   projectId: "ccms-main-qe",
//   storageBucket: "ccms-main-qe.appspot.com",
//   messagingSenderId: "953826033978",
//   appId: "1:953826033978:web:1147e23b1a06e179811003",
//   measurementId: "G-DRETX2H6X6",
// };

let app = null;
let db = null;
let auth = null;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  withoutLabel: {
    marginTop: theme.spacing(3),
  },
  textField: {},
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    opacity: 0.5,
  },
}));

export const loginViewMode = {
  START: "START",
  LOGIN: "LOGIN",
  DB_SETTINGS: "DB_SETTINGS"
};

function Login() {
  const classes = useStyles();
  const history = useHistory();
  const [loginForm, setLoginForm] = useState({
    username: "",
    password: "",
  });
  const [isAPILoading, setIsAPILoading] = useState(false);

  const [userCredential, setUserCredential] = useState({});
  const [userData, setUserData] = useState({});
  const [dbList, setDbList] = useState({});
  const [viewMode, setViewMode] = useState(loginViewMode.START);
  const [selectedArea, setSelectedArea] = useState("");

  const handleFormChange = (fieldName) => (e) => {
    const { target: { value = "" } = {} } = e;
    setLoginForm((prevState) => ({
      ...prevState,
      [fieldName]: value,
    }));
  };

  // const callAuthenticateAPI = async (
  //   email,
  //   password,
  //   firebaseConfigApiResponse
  // ) => {
  //   console.log("firebase apps : ", getApps());
  //   if (!getApps().length) {
  //     app = initializeApp(firebaseConfigApiResponse);
  //   }
  //   db = getFirestore();
  //   auth = getAuth();
  //   signInWithEmailAndPassword(auth, email, password)
  //     .then((userCredential) => {
  //       localStorage.setItem("userEmail", email);
  //       // Signed in
  //       const user = userCredential.user;
  //       console.log("successssss !!!");
  //       localStorage.setItem("isAuthenticated", true);
  //       localStorage.setItem(
  //         "firebaseConfigApiResponse",
  //         JSON.stringify(firebaseConfigApiResponse)
  //       );
  //       setIsAPILoading(false);
  //       NotificationManager.success("User successfully logged in", "", 3000);
  //       history.push("/dashboard");
  //     })
  //     .catch((error) => {
  //       const errorCode = error.code;
  //       const errorMessage = error.message;
  //       console.log("Failure !!!!");
  //       localStorage.setItem("isAuthenticated", false);
  //       setIsAPILoading(false);
  //       NotificationManager.error("Invalid login details", "", 3000);
  //     });
  // };

  const validateSession = async () => {
    let userCredential = await checkMasterSession().catch((error) => {
      showLoginView();
      return Promise.reject();
    });

    let username = await getUserName().catch((error)=> {
      showLoginView();
      return Promise.reject();
    });

    const userDbSetting = await getUserDbSettings(username).catch((error) => {
      console.log(error);
      masterLogout();
      showLoginView();
      return Promise.reject();
    });
    console.log(`\n\n ******* Login Success ******* \n\n`);
    setUserName(username);
    setUserAccessList(userDbSetting?.userDoc?.access_web);
    setIsAdmin(userDbSetting?.userDoc?.admin === true);
    showDbSelectionView(userCredential, userDbSetting.userDoc, userDbSetting.dbSettingsList);
    Promise.resolve();
  };

  useEffect(() => {

    //localStorage.removeItem("firebaseConfigApiResponse");
    validateSession().then(()=>{}).catch(()=>{});



    // var sessionStatus = await getCheckSession();
    // if (sessionStatus) {
    //   history.push("/dashboard");
    // }



    // await getCheckSession().then(() => {
      
    // }).catch((e) => {
    // });
    
    let dbName = "";
    // const url =
    //   "https:/us-central1-ccms-main-qe.cloudfunctions.net/user?userEmail=admin@admin.com&clientType=2";
    // fetch(url)
    //   .then((res) => res.json())
    //   .then((data) => console.log("data : ", data))
    //   .catch((err) => console.log(err));

    // getDbData();
    // callAuthenticateAPI("sudhankumarr@gmail.com", "123456");

    // const q = query(collection(db, "users"), where("user_email", "==", "sudhankumarr@gmail.com"));
    // const querySnapshot = await getDocs(q);
    // querySnapshot.forEach(doc => {
    //   console.log("users docs : ", doc.data());
    //   let selectedDoc = doc.data();
    //   dbName = selectedDoc.db_name;
    // });
    // console.log('db name : ', dbName);
    // let firebaseConfig_specific_city = null;

    // const docRef = doc(db, "db_settings", `${dbName}_web`);
    // const docSnap = await getDoc(docRef);
    // if (docSnap.exists()) {
    //   console.log('doc snap config : ', docSnap.data());
    //   firebaseConfig_specific_city = docSnap.data();
    // }

    // if (firebaseConfig_specific_city) {
    //   initializeApp(firebaseConfig_specific_city);
    // }
  }, []);

  // const handleLogin = async () => {
  //   const { username = "", password = "" } = loginForm;
  //   setIsAPILoading(true);
  //   const { status, data: firebaseConfigApiResponse } = await checkLoginDetailsApi(username);
  //   console.log("response : ", firebaseConfigApiResponse, status);
  //   if (status) {
  //     // callAuthenticateAPI(username, password);
  //     callAuthenticateAPI(username, password, firebaseConfigApiResponse);
  //   } else {
  //     localStorage.setItem("isAuthenticated", false);
  //     setIsAPILoading(false);
  //     NotificationManager.error("Invalid login details", "", 3000);
  //   }
  // };

  const showLoginView = () => {
    //TODO: reset all credentials, all signout
    setViewMode(loginViewMode.LOGIN);
  };

  const showDbSelectionView = async (userCredentials, userDoc, dbSettingsList) => {
    setUserCredential(userCredentials);
    setUserData(userDoc);
    setDbList(dbSettingsList);
    setViewMode(loginViewMode.DB_SETTINGS);
  };

  const getUserDbSettings = async (username) => {
    // get user Doc
    let userDoc = await getUser(username).catch((error) => {
      return Promise.reject("User not found, please contact administrator");
    });
    
    console.log("Fetched User Document from users collection: ", userDoc);

    if (userDoc["db_list"] == null || userDoc["db_list"].length <= 0) {
      return Promise.reject("Area not attched to the user, please contact administrator");
    }
    let dbSettingsList=[];
    var flag = false; 
   
    if( userDoc['access_web'] != null && userDoc['access_web'] != undefined ){
      flag = userDoc['access_web'].find(i => i === "all_db");
    }
    if(flag){
      dbSettingsList = await getAllDbSettingList().catch((error) => {
        return Promise.reject("Area not attched to the user, please contact administrator");
      });
       return Promise.resolve({userDoc,dbSettingsList});
     } else {
         dbSettingsList = await getDbSettingList(userDoc["db_list"]).catch((error) => {
      return Promise.reject("Area not attched to the user, please contact administrator");
    });
       return Promise.resolve({userDoc,dbSettingsList});
  }
  };

  const onClickLogin = async () => {
    setIsAPILoading(true);
    await handleLogin().then(()=>{}).catch(()=>{});
    setIsAPILoading(false);
  };

  const handleLogin = async () => {
    const { username = "", password = "" } = loginForm;    
    // login with email and password
    let userCredential = await logInWithEmailAndPassword(username, password).catch((error) => {
      console.log(`\n\n ******* Login Failed ******* \n\n ${error}`);
      NotificationManager.error("Unable to login, please try after sometime", "", 3000);
      return Promise.reject();
    });

    // get user doc and setting
    const userDbSetting = await getUserDbSettings(username).catch(async (error) => {
      await masterLogout();
      NotificationManager.error(error, "", 3000);
      return Promise.reject();
    });
    console.log(`\n\n ******* Login Success ******* \n\n`);
    setUserName(username);
    setUserAccessList(userDbSetting?.userDoc?.access_web);
    setIsAdmin(userDbSetting?.userDoc?.admin === true);
    showDbSelectionView(userCredential, userDbSetting.userDoc, userDbSetting.dbSettingsList);
    Promise.resolve();
  };

  const handleKeyDown = async (e) => {
    if (e.keyCode === 13) {
      console.log("ee : ", e);
      setIsAPILoading(true);
      await handleLogin().then(()=>{}).catch(()=>{});
      setIsAPILoading(false);
    }
  };

  const onChangeAreaSelect = (event, child) => {
    console.log(event.target.value);
    console.log(child);
    setSelectedArea(event.target.value);
  };

  const onClickLogout = async () => {
    await masterLogout();
    setViewMode(loginViewMode.LOGIN);
    NotificationManager.success("User logged out Successfully", "", 3000);
  };

  const onClickSelectArea = async () => {
    if (selectedArea === "") {
      NotificationManager.error("Please select area to continue", "", 3000);
      return;
    }
    setIsAPILoading(true);
    await selectArea().then(()=> {
      history.push("/dashboard");
    }).catch((error)=> {
      setIsAPILoading(false);
      NotificationManager.error("Unable to load area, please contact administrator", "", 3000);
    });
  };

  const selectArea = async () => {
    // get current user ID Token
    let idToken = await getIdToken(userCredential).catch((error)=> {
      return Promise.reject(error);
    });

    let customTokenRes = await getServiceCustomToken(idToken, selectedArea).catch((error)=> {
      return Promise.reject(error);
    });

    if (!customTokenRes || !customTokenRes.cus_token) {
      return Promise.reject("Unable to get customToken");
    }

    let dbConfig = dbList.find(element => element.dbName === selectedArea);

    if (dbConfig == null) {
      return Promise.reject("Unable to get config");
    }
    const firebaseConfig = {
      ...dbConfig,
      apiKey: dbConfig?.web?.apiKey,
      authDomain: dbConfig?.web?.authDomain,
      appId: dbConfig?.web?.appId,
      measurementId: dbConfig?.web?.measurementId,

      storageBucket: dbConfig?.storageBucket,
      projectId: dbConfig?.projectId,
      messagingSenderId: dbConfig?.messagingSenderId,
    };
    setServiceConfig(firebaseConfig);

    // login with custom token
    let customToken = await logInWithCustomToken(customTokenRes.cus_token).catch((error)=> {
      return Promise.reject(error);
    });

    return Promise.resolve();
  };



  const { username = "", password = "" } = loginForm;
  return (
    <div style={{ height: "100vh" }}>
      {isAPILoading && (
        <Backdrop open={true} className={classes.backdrop}>
          <CircularProgress
            className="circular-progress-center"
            disableShrink
          />
        </Backdrop>
      )}
      <img src={loginBgImg} className="login-image" />
      <Grid container style={{ height: "100%" }}>
        {/* <Grid item xs={6}>
        </Grid> */}
         {(viewMode === loginViewMode.START) && (
          <Grid item xs={12} className="theme-bg">
          <Grid
            container
            // direction="column"
            alignItems="center"
            justifyContent="center"
            style={{ height: "100%" }}
          >
            {/* <div className="start-login-wrapper">
              <h4 style={{ marginTop: 0 }}>Log In</h4>
              <div style={{ display: "flex", flexDirection: "column" }}>
                
              </div>
            </div> */}
            <div
              className="d-flex"
              style={{ flexDirection: "column", marginLeft: "5%" }}
            >
              <img
                src={amuraLogo}
                className=""
                style={{ width: "176px", marginBottom: "50px" }}
              />
              <img src={LightUpTextImg} className="" />
            </div>
          </Grid>
          </Grid> 
        )}
        {(viewMode === loginViewMode.LOGIN) && (
          <Grid item xs={12} className="theme-bg">
          <Grid
            container
            // direction="column"
            alignItems="center"
            justifyContent="center"
            style={{ height: "100%" }}
          >
            <div className="login-wrapper">
              <h4 style={{ marginTop: 0 }}>Log In</h4>
              <div style={{ display: "flex", flexDirection: "column" }}>
                {/* <TextField
                  id="username"
                  name="username"
                  value={username}
                  onChange={handleFormChange}
                  label="Username"
                /> */}
                <FormControl
                  className={clsx(classes.margin, classes.textField)}
                  variant="outlined"
                >
                  <InputLabel htmlFor="outlined-adornment-username">
                    User name
                  </InputLabel>
                  <OutlinedInput
                    id="outlined-adornment-username"
                    type="text"
                    value={username}
                    onChange={handleFormChange("username")}
                    onKeyDown={handleKeyDown}
                    startAdornment={
                      <InputAdornment position="start">
                        <PersonIcon />
                      </InputAdornment>
                    }
                    labelWidth={80}
                  />
                </FormControl>
                {/* <TextField
                  type="password"
                  id="password"
                  name="password"
                  value={password}
                  onChange={handleFormChange}
                  label="Password"
                /> */}
                <FormControl
                  className={clsx(classes.margin, classes.textField)}
                  variant="outlined"
                >
                  <InputLabel htmlFor="outlined-adornment-password">
                    Password
                  </InputLabel>
                  <OutlinedInput
                    id="outlined-adornment-password"
                    type="password"
                    value={password}
                    onChange={handleFormChange("password")}
                    onKeyDown={handleKeyDown}
                    startAdornment={
                      <InputAdornment position="start">
                        <LockIcon />
                      </InputAdornment>
                    }
                    labelWidth={70}
                  />
                </FormControl>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <FormControlLabel
                  control={<Checkbox value="remember" color="primary" />}
                  label="Remember me"
                //   style={{ fontSize: "1.3em" }}
                />
                <Button className="forgot-password-btn">
                  Forgot Password?
                </Button>
              </div>
              <Button
                variant="contained"
                className="login-btn"
                style={{ textTransform: "none", marginTop: 10 }}
                onClick={onClickLogin}
              >
                Login
              </Button>
            </div>

            <div
              className="d-flex"
              style={{ flexDirection: "column", marginLeft: "5%" }}
            >
              <img
                src={amuraLogo}
                className=""
                style={{ width: "176px", marginBottom: "50px" }}
              />
              <img src={LightUpTextImg} className="" />
            </div>
          </Grid>
          </Grid> 
        )}

        {(viewMode === loginViewMode.DB_SETTINGS) && 
          <Grid item xs={12} className="theme-bg">
          <Grid
            container
            // direction="column"
            alignItems="center"
            justifyContent="center"
            style={{ height: "100%" }}
          >
            <div className="area-select-wrapper">
              <h4 style={{ marginTop: 0 }}>Select Region</h4>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <FormControl className={clsx(classes.margin, classes.textField)} variant="outlined">
                  <InputLabel htmlFor="area-select-label">
                    Region
                  </InputLabel>
                  <Select
                    labelId="area-select-label"
                    id="area-select"
                    value={selectedArea}
                    label="Area"
                    onChange={onChangeAreaSelect}
                  >
                    {dbList.map((item)=>(<MenuItem key={item["dbName"]} value={item["dbName"]}>{item["displayName"]}</MenuItem>))}
                  </Select>
                </FormControl>
              </div>
              <Button
                variant="contained"
                className="select-area-btn"
                style={{ textTransform: "none", marginTop: 40 }}
                onClick={onClickSelectArea}>
                Continue
              </Button>
              <Button
                variant="contained"
                className="logout-btn"
                style={{ textTransform: "none", marginTop: 40 }}
                onClick={onClickLogout}>
                Logout
              </Button>
              
            </div>

            <div
              className="d-flex"
              style={{ flexDirection: "column", marginLeft: "5%" }}
            >
              <img
                src={amuraLogo}
                className=""
                style={{ width: "176px", marginBottom: "50px" }}
              />
              <img src={LightUpTextImg} className="" />
            </div>
          </Grid>
          </Grid> 
        }

        {/* {(viewMode === loginViewMode.DB_SETTINGS) && 
          dbList.map((item)=>(
            <Grid item xs={12} className="theme-bg">
          <Grid
            container
            // direction="column"
            alignItems="center"
            justifyContent="center"
            style={{ height: "100%" }}
          >
            <div className="login-wrapper">
              <h4 style={{ marginTop: 0 }}>{item["displayName"]}</h4>
            </div>
            </Grid>
            </Grid>
            // <Grid item xs={6} md={8}>
            //   <div>
            //     <h1>
            //       {item["displayName"]}
            //     </h1>
            //   </div>
            // </Grid>
          ))
          
        } */}
        
      </Grid>
    </div>
  );
}

export default Login;
